class HeaderDropdownList extends HTMLUListElement {
  constructor() {
    super();
    this.dropdowns = [];
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
  }

  connectedCallback() {
    this.dropdowns = this.querySelectorAll(
      ".header-nav__dropdown,.header-nav__submenu-dropdown"
    );
    this.dropdowns.forEach((dropdown) => {
      this.setupDropdown(dropdown);
    });
    document.addEventListener("click", this.boundHandleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  setupDropdown(dropdown) {
    const summary = dropdown.querySelector("summary");
    const submenu = summary.nextElementSibling;

    if (!summary || !submenu) return;

    summary.addEventListener("keydown", (e) =>
      this.handleDropdownKeydown(e, dropdown, summary)
    );
    dropdown.addEventListener("mouseenter", () =>
      this.handleDropdownMouseEnter(dropdown, summary)
    );
    dropdown.addEventListener("mouseleave", () =>
      this.handleDropdownMouseLeave(dropdown, summary)
    );
    dropdown.addEventListener("toggle", () =>
      this.handleDropdownToggle(dropdown, summary)
    );
  }

  handleDropdownKeydown(e, dropdown, summary) {
    if (e.key === "Enter" && e.target.href) {
      return;
    }

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.toggleDropdown(dropdown, summary);
    } else if (e.key === "Escape") {
      this.closeDropdown(dropdown, summary);
      summary.focus();
    }
  }

  handleDropdownToggle(dropdown, summary) {
    const isOpen = dropdown.hasAttribute("open");
    summary.setAttribute("aria-expanded", isOpen.toString());
  }

  handleDropdownMouseEnter(dropdown, summary) {
    // Close other level 1 dropdowns when opening a new one
    if (dropdown.classList.contains("header-nav__dropdown")) {
      this.dropdowns.forEach((other) => {
        if (other !== dropdown) {
          this.closeDropdown(other, other.querySelector("summary"));
        }
      });
    }
    this.openDropdown(dropdown, summary);
  }

  handleDropdownMouseLeave(dropdown, summary) {
    this.closeDropdown(dropdown, summary);
  }

  toggleDropdown(dropdown, summary) {
    const isOpen = dropdown.hasAttribute("open");
    if (isOpen) {
      this.closeDropdown(dropdown, summary);
    } else {
      this.openDropdown(dropdown, summary);
    }
  }

  openDropdown(dropdown, summary) {
    dropdown.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");
  }

  closeDropdown(dropdown, summary) {
    dropdown.removeAttribute("open");
    if (summary) {
      summary.setAttribute("aria-expanded", "false");
    }
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      this.closeDropdown(dropdown, dropdown.querySelector("summary"));
    });
  }

  handleClickOutside(e) {
    if (!this.contains(e.target)) {
      this.closeAllDropdowns();
    }
  }
}
customElements.define("header-dropdown", HeaderDropdownList, { extends: "ul" });
